import { defineSlotRecipe } from '@chakra-ui/react';
import { tagDarkVariant, tagLightVariant } from '@theme/variants/tag';

export const tagSlotRecipe = defineSlotRecipe({
  className: 'chakra-tag',
  slots: ['root', 'closeTrigger', 'label', 'startElement', 'endElement', 'closeTrigger'],
  base: {
    root: {
      display: 'flex',
      alignItems: 'center',
      maxWidth: '100%',
      userSelect: 'none',
      backgroundColor: 'transparent !important',
      borderRadius: 'none',
      border: '2px solid',
      borderColor: 'neutral.600',
      gap: 1,
      '&[data-active=true]': {
        zIndex: 1,
        borderColor: 'blue.500',
        backgroundColor: 'blue.700 !important',
        boxShadow: 'none !important',
      },
      '&[data-active=false]': {
        boxShadow: 'none !important',
      },
      '&:hover': {
        borderColor: 'skyBlue',
        zIndex: 2,
      },
      '&[data-disabled=true]': {
        borderColor: 'neutral.600',
        backgroundColor: 'transparent !important',
      },
    },
    label: {
      lineClamp: '1',
      gap: 1,
      color: 'neutral.white',
      '&[data-disabled=true]': {
        color: 'neutral.500',
      },
    },
    endElement: {
      textStyle: 'md',
      lineHeight: '18px',
      width: 'fit-content',
      height: 'fit-content',
      fontWeight: 'medium',
      color: 'skyblue',
      textTransform: 'capitalize',
      margin: 0,
      boxSizing: 'border-box',
      '&[data-disabled=true]': {
        color: 'neutral.500',
      },
    },
  },
  variants: {
    size: {
      md: {
        root: {
          paddingX: 1,
          paddingTop: 0,
          height: '32px',
        },
        label: {
          textStyle: 'sm',
        },
      },
      lg: {
        root: {
          paddingX: 3,
          paddingY: 1.5,
          height: '48px',
        },
        label: {
          textStyle: 'sm',
        },
      },
    },
    variant: {
      light: tagLightVariant,
      dark: tagDarkVariant,
    },
  },
  defaultVariants: {
    size: 'md',
  },
});
